import { render, staticRenderFns } from "./ListaNotifiche.vue?vue&type=template&id=e0a2da64&"
import script from "./ListaNotifiche.vue?vue&type=script&lang=js&"
export * from "./ListaNotifiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports